export default __webpack_public_path__ + "static/media/lend-bean.c898f870.svg";